import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";
import { PHILOSOPHY } from "@/lib/assets";

export const Manifesto = () => {
  const { t } = useLanguage();
  const go = () =>
    document.querySelector("#consultation")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-32 sm:py-48 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={PHILOSOPHY.ambiance}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0A1420]/92" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(10,20,32,0.55)_0%,rgba(10,20,32,0.94)_78%)]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 sm:px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-[#D4AF37] tracking-[0.35em] uppercase text-xs"
        >
          {t("manifesto.eyebrow")}
        </motion.p>
        <motion.blockquote
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8 font-serif-lux text-3xl sm:text-4xl lg:text-5xl leading-tight text-white"
          data-testid="manifesto-line"
        >
          {t("manifesto.line1")}
          <span className="gold-gradient-text italic">{t("manifesto.lineAccent")}</span>
        </motion.blockquote>
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          onClick={go}
          data-testid="manifesto-cta"
          className="mt-12 border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0A1420] transition-colors duration-300 px-10 py-4 uppercase tracking-widest text-xs"
        >
          {t("manifesto.cta")}
        </motion.button>
      </div>
    </section>
  );
};
